// frontend/shared-ui/src/components/Card.jsx
import React from "react";

export default function Card({
  title,
  subtitle,
  actions,
  footer,
  children,
  hoverable = false,
  className = "",
}) {
  return (
    <div
      className={`fh-card ${hoverable ? "fh-card--hoverable" : ""} ${className}`}
    >
      {(title || subtitle || actions) && (
        <div className="fh-card__header">
          <div>
            {title && <h5 className="fh-card__title">{title}</h5>}
            {subtitle && <p className="fh-card__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="fh-card__actions">{actions}</div>}
        </div>
      )}
      <div className="fh-card__body">{children}</div>
      {footer && <div className="fh-card__footer">{footer}</div>}
    </div>
  );
}
